import React from "react";
import { ModalHeader } from "nvs-design-system/dist/Modals/RoundedModal/components/ModalHeader";
import { ModalBody } from "nvs-design-system/dist/Modals/RoundedModal/components/ModalBody";
import TokenTransferStep, {
  TokenTransferStepProps,
} from "../../TokenTransferStep";
import { Body5 } from "@/src/components/typography/components/Body";
import { TextLink } from "@/src/components/links/components/TextLink";
import { CUSTOMER_SUPPORT_LINK } from "@/constants/externalLinks";

export default function TransferFailed({
  isShowing = false,
}: TokenTransferStepProps) {
  return (
    <TokenTransferStep isShowing={isShowing}>
      <ModalHeader className="max-w-72 laptop:max-w-full">
        Something went wrong.
      </ModalHeader>

      <ModalBody className="flex flex-col gap-6">
        <BodyCopy />
      </ModalBody>
    </TokenTransferStep>
  );
}

function BodyCopy() {
  return (
    <Body5>
      Please contact&nbsp;
      <TextLink
        linkType="underlined"
        className="normal-case text-gray-950"
        href={CUSTOMER_SUPPORT_LINK}
      >
        Customer Support
      </TextLink>
      &nbsp;for further assistance.
    </Body5>
  );
}
